import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserDetails } from '../../model/userdetails';

@Injectable()
export class DataService {
    private modules = new BehaviorSubject(new Array<number>());
    currentModules = this.modules.asObservable();

    private userDetails = new BehaviorSubject(new UserDetails());
    currentUserDetails = this.userDetails.asObservable();

    constructor() { }

    changeModules(modules: Array<number>) {
        this.modules.next(modules);
    }

    changeUserDetails(userDetails: UserDetails) {
        this.userDetails.next(userDetails);
    }
}